var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmojiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3439_19986)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.00195,
    cy: 6,
    r: 5.29102,
    stroke: "#C1C7D4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.03877 7.17578C7.63218 7.87866 6.87222 8.35156 6.00181 8.35156C5.1314 8.35156 4.37144 7.87866 3.96484 7.17578",
    stroke: "#C1C7D4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.27926,
    cy: 4.3663,
    r: 0.673792,
    fill: "#C1C7D4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.36129,
    cy: 4.3663,
    r: 0.673792,
    fill: "#C1C7D4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3439_19986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiLogo);
export default __webpack_public_path__ + "static/media/emojiLogo.69c66125171e37ed2f8db0318fe05f7b.svg";
export { ForwardRef as ReactComponent };